module.exports = __webpack_public_path__ + "media/images/orion_pictos/school-8188ce9ebfcf11409a133e2be3723fd1.svg";